import { ThemeProvider } from '@emotion/react';
import { theme, GlobalStyle } from './component-library';
import AuthenticatedApp from './authenticatedApp';
import { useAuth } from './context/authContext';
import { Error } from './screens';
import { Routes, Route } from 'react-router-dom';

function App() {
  const { userIsAuthenticated } = useAuth();

  return (
    <ThemeProvider theme={theme}>
      <GlobalStyle />
      {userIsAuthenticated ? (
        <AuthenticatedApp />
      ) : (
        <Routes>
          <Route path='error' element={<Error />} />
        </Routes>
      )}
    </ThemeProvider>
  );
}

export default App;
